<form [formGroup]="form" class="row">
	<mat-form-field class="col">
		<mat-label>{{ matLabel }}</mat-label>
		<input matInput aria-label="Confirm Password" [type]="hide ? 'password' : 'text'" [placeholder]="placeholder"
			[name]="controlName" [formControlName]="controlName" [matAutocomplete]="auto" />
		<button type="button" mat-icon-button matSuffix (click)="toggleHide()" [attr.aria-label]="'Hide password'"
			[attr.aria-pressed]="hide" tabindex="-1">
			<mat-icon>{{hide ? "visibility_off" : "visibility"}}</mat-icon>
		</button>
	</mat-form-field>
	<app-msg class="msg-position" *ngIf="!isLoading && (msg && !msg.SUCCESS)" [msg]="msg"></app-msg>

	<mat-autocomplete #auto="matAutocomplete" [hidden]="true">
		<mat-option *ngFor="let option of passwordConfirmOptions | async" [value]="option.name">
		</mat-option>
	</mat-autocomplete>
</form>